export const SET_LOADING_TRUE = "SET_LOADING_TRUE";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";

export const SET_CURRENT_MODAL = "SET_CURRENT_MODAL";
export const SET_SWALLOW_EO = "SET_SWALLOW_EO";

export const SET_SELECTED_EVENT = "SET_SELECTED_EVENT";
export const CLEAR_SELECTED_EVENT = null;

export const LOGIN_MODAL = "LOGIN_MODAL";
export const SIGNUP_MODAL = "SIGNUP_MODAL";
export const FORGET_MODAL = "FORGET_MODAL";
export const RESET_MODAL = "RESET_MODAL";
export const CLEAR_MODAL = "";
export const VERIFY_MODAL_TOGGLE = "VERIFY_MODAL_TOGGLE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

// export const CATER_RATING_DOC = "Rating";
// export const CATER_REGISTERED_DOC = "Registered";
export const CATER_RATING_DOC = "'Score on the Floors' Rating";
export const CATER_REGISTERED_DOC = "Local Authority Registered";
export const CATER_TRAINING_DOC = "Training";
export const CATER_GAS_CERT_DOC = "GasCert";
export const CATER_POLICY_DOC = "PolicyStatement";
export const CATER_NICEIC_DOC = "Niceic";
export const CATER_LICENSE_DOC = "PersonalLicense";
export const CATER_PLICERT_DOC = "PliCert";
export const CATER_ELICERT_DOC = "EliCert";
export const CATER_HACCP_DOC = "HaccpDoc";

export const GET_EVENT_CATEGORIES = "GET_EVENT_CATEGORIES";
export const GET_EVENTS_BY_CATEGORY = "GET_EVENTS_BY_CATEGORY";

export const GET_ALL_USER_ROLES = "GET_ALL_USER_ROLES";
export const SET_ACTIVE_ROLE = "SET_ACTIVE_ROLE";
